<div [classList]="canvas">
    <!-- *ngIf="isSidePanelOpen" -->
    <div id="mySidepanel" [classList]="open1">
        <div fxLayout="column wrap" fxFlex="100" class="editForm">
            <div class="headContent">
                <span class="head"> <b>Sales Person Details: </b></span>
                <i id="closeX" (click)="closeEdit()" class="flaticon-close"></i>
            </div>
            <logzy-quick-add-salesperson [bindName]="bindName"
                (salesAdded)="bindSalesPerson($event)"></logzy-quick-add-salesperson>
        </div>
    </div>
</div>
<div class="container-type" fxLayout="row wrap">
    <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name!='lease'">
        <logzy-view-data-field label="Master Agreement No." [name]="requestService.selectedRequest"
            [displayField]="'requestor'" [displayField1]="'company'" [displayField2]="'master_agreement_no'"
            fxFlex="192px" fxLayout="column" class="align-items-center"></logzy-view-data-field>
        <logzy-view-data-field label="Agreement Valid till" [name]="requestService.selectedRequest"
            [displayField]="'requestor'" [displayField1]="'company'" [displayField2]="'master_agreement_valid_till'"
            fxFlex="192px" fxLayout="column" class="align-items-center"></logzy-view-data-field>
    </ng-container>
    <app-mat-auto-search label="Lead Entry Source*" [isEditable]="true" [(ngModel)]="requestUpdateObj.request_source"
        [(errors)]="requestUpdateObj.error.request_source" [idField]="'value'" [displayField]="'value'"
        [name]="'request_source'" [searchable]="false" [options]="leadSourceList?.results" [clearable]="false"
        fxFlex="192px" fxLayout="column"></app-mat-auto-search>


    <app-text-field label="Reference No./Referrer" [isEditable]="true" [name]="'external_reference_no'" fxFlex="192px"
        fxLayout="column" [(ngModel)]="requestUpdateObj.external_reference_no"
        [(errors)]="requestUpdateObj.error.external_reference_no">
    </app-text-field>

    <app-text-field label="Old Booking No." [isEditable]="true" [name]="'old_booking_number'" fxFlex="192px"
        fxLayout="column" [(ngModel)]="requestUpdateObj.old_booking_number"
        [(errors)]="requestUpdateObj.error.old_booking_number">
    </app-text-field>

    <app-text-field label="Remarks" [isEditable]="true" [name]="'remarks'" [isMultiline]="true" fxFlex="192px"
        fxLayout="column" [(ngModel)]="requestUpdateObj.remarks" [(errors)]="requestUpdateObj.error.remarks">
    </app-text-field>

    <app-mat-auto-search [isEditable]="true" [searchIcon]="true" fxFlex="192px" fxLayout="column"
        [label]="'Sales Person*'" [setSearchValue]="isCustomer ? false : true" [name]="'sales_person'"
        [(ngModel)]="requestUpdateObj.sales_person" class="requestorInput" (ngModelChange)="getSalesDetails($event)"
        [idField]="null" [listUrl]="userMaster_url+'user_list/?search=::search::&o=first_name&is_internal=1'"
        [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem"
        [(errors)]="requestUpdateObj.error.sales_person"></app-mat-auto-search>

    <!-- Operations person Details -->
    <app-mat-auto-search [isEditable]="true" [searchIcon]="true" fxFlex="192px" fxLayout="column"
        [label]="'Operations User'" [name]="'sales_person'" [(ngModel)]="requestUpdateObj.operations_user"
        class="requestorInput" [idField]="null"
        [listUrl]="userMaster_url+'user_list/?search=::search::&o=first_name&is_internal=1'"
        [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem"
        [(errors)]="requestUpdateObj.error.sales_person"></app-mat-auto-search>

    <!-- Billing Entity Details -->
    <app-mat-auto-search [isEditable]="true" [searchIcon]="true" fxFlex="192px" fxLayout="column" [label]="'Billing Entity'"
        [name]="'sales_person'" [(ngModel)]="requestUpdateObj.billing_entity" class="requestorInput" [idField]="null"
        [listUrl]="company_url" [displayField]="'name'"
        [(errors)]="requestUpdateObj.error.billing_entity"></app-mat-auto-search>
        <div class="requestorInput" fxFlex="192px">

        </div>

    <div fxFlex="100" class="updateReq">
        <button mat-raised-button (click)="patchRequest()" class="Save">Save Request</button>
    </div>
</div>

<!-- User template for dropdown -->
<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.first_name}} {{item?.last_name}}
        </span>
        <div class="email">
            <i class="flaticon-email"></i>
            <span>{{item?.email}}</span>
        </div>

        <div class="company">
            <i class="flaticon-office"></i>
            <span>{{item?.company?.name}}
            </span>
        </div>
    </div>
</ng-template>
<ng-template #userSelectedItem let-item>
    {{item?.first_name}} {{item?.last_name}}
</ng-template>
